import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { WindowComponent } from './window/window.component';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './services/auth-guard.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SignupComponent } from './signup/signup.component';
import { SubmitComponent } from './submit/submit.component'
import { AdminComponent } from './admin/admin.component';
import { BlogComponent } from './blog/blog.component';
import { VerifyComponent } from './verify/verify.component';
import { YourTipJarComponent } from './your-tip-jar/your-tip-jar.component';
import { MyvideosComponent } from './myvideos/myvideos.component';
import { BookmarkedComponent } from './bookmarked/bookmarked.component';
import { environment } from 'src/environments/environment';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { PaymentComponent } from './payment/payment.component';
import { PrimeGuard } from './services/prime.guard';
import { AdminGuard } from './services/admin.guard';
import { LondonCityVideosComponent } from './cities-filtered-videos/london-city-videos/london-city-videos.component';
import { NewYorkCityVideoComponent } from './cities-filtered-videos/new-york-city-video/new-york-city-video.component';
import { EditProfileComponent } from './user-setting/edit-profile/edit-profile.component';
import { UserSettingComponent } from './user-setting/user-setting/user-setting.component';
import { ChangePasswordComponent } from './user-setting/change-password/change-password.component';
import { AllAccessComponent } from './user-setting/all-access/all-access.component';
import { ChangePaymentModeComponent } from './user-setting/change-payment-mode/change-payment-mode.component';
import { AllaccessguardService } from './services/allaccessguard.service';
import { CloseAccountComponent } from './user-setting/close-account/close-account.component';
import { TermsComponent } from './terms/terms.component';
import { GiftComponent } from './gift/gift.component';
import { GiftCheckoutComponent } from './gift-checkout/gift-checkout.component';
import { GiftSuccessComponent } from './gift-success/gift-success.component';
import { AboutGazeComponent } from './about-gaze/about-gaze.component';
import { GazePolicyComponent } from './gaze-policy/gaze-policy.component';
import { GazeDeleteAccountComponent } from './gaze-delete-account/gaze-delete-account.component';
import { GazeSupportComponent } from './gaze-support/gaze-support.component';
const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'signup/#',
    component: SignupComponent
  },
  {
    path: 'Window',
    component: WindowComponent
  },
  {
    path: 'Window/:from',
    component: WindowComponent
  },
  {
    path: '0/:from',
    component: WindowComponent
  },
  {
    path: 'verify',
    component: VerifyComponent
  },
  {
    path: 'terms',
    component:TermsComponent
  },
  {
    path: `${environment.CAMPAIGN_URL}`,
    component: WindowComponent
  },
  {
    path: 'pricing',
    component: SubscriptionsComponent,
    canActivate: [PrimeGuard]
  },
  {
    path: 'payment',
    component: PaymentComponent,
    canActivate: [PrimeGuard, AuthGuardService]
  },
  {
    path: 'blog',
    component: BlogComponent
  },
  {
    path: 'blog/tipjar',
    component: BlogComponent
  },
  {
    path: 'user',
    canActivate: [AuthGuardService],
    component: UserProfileComponent,
    children: [
      { path: 'mywindow', component: MyvideosComponent },
      { path: 'tipjar', component: YourTipJarComponent },
      { path: '', component: BookmarkedComponent },
      { path: 'reauth', component: YourTipJarComponent },
      { path: 'return', component: YourTipJarComponent },
    ]
  },
  {
    path: 'user-setting',
    canActivate: [AuthGuardService],
    component: UserSettingComponent,
    children: [
      { path: '', component: EditProfileComponent },
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'all-access', component: AllAccessComponent, canActivate: [AllaccessguardService] },
      { path: 'change-payment-method', component: ChangePaymentModeComponent, canActivate: [AllaccessguardService] },
      { path: 'close-account', component: CloseAccountComponent },
    ]
  },
  {
    path: 'submit',
    canActivate: [AuthGuardService],
    component: SubmitComponent,
  },
  {
    path: 'admin',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/approved',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/rejected',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/failed',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/uploaded',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/uploaded/1',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/gdrive',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/curated',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'admin/curated/1',
    canActivate: [AdminGuard],
    component: AdminComponent,
  },
  {
    path: 'cities/london',
    component: LondonCityVideosComponent,
  },
  {
    path: 'newyork',
    component: NewYorkCityVideoComponent,
  },
  {
    path: 'london',
    component: NewYorkCityVideoComponent,
  },
  {
    path: 'sendGift',
    component: GiftComponent,
  },
  {
    path: 'giftCheckout',
    component: GiftCheckoutComponent,
  },
  {
    path: 'giftSuccess',
    component: GiftSuccessComponent,
  },
  {
    path: 'about-gaze',
    component: AboutGazeComponent,
  },
  {
    path: 'gaze-terms',
    component: GazePolicyComponent,
    data: { type: 'terms' }
  },
  {
    path: 'gaze-privacy',
    component: GazePolicyComponent,
    data: { type: 'privacy' }
  },
  {
    path: 'gaze-delete-account',
    component: GazeDeleteAccountComponent
  },
  {
    path: 'gaze-support',
    component: GazeSupportComponent
  },
  { path: '**', redirectTo: '/' }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // Automatically scrolls to the top on navigation
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
